import { createSlice } from '@reduxjs/toolkit';
import getAdapter from '../getAdapter';

const deductionRulesAdapter = getAdapter({ idFieldName: 'text' });

const deductionRulesSlice = createSlice({
  name: 'deductionRules',
  initialState: deductionRulesAdapter.getInitialState(),
  reducers: {
    setDeductionRules: (state, { payload: { deductionRules } }) => {
      deductionRulesAdapter.setAll(state, deductionRules);
    },
  },
});

const selectors = deductionRulesAdapter.getSelectors(({ deductionRules }) => deductionRules);

export const getDeductionRules = (state) => selectors.selectAll(state);

export const { setDeductionRules } = deductionRulesSlice.actions;

export default deductionRulesSlice.reducer;
